import { render, staticRenderFns } from "./CreateNomenclature.vue?vue&type=template&id=5a94a7dc&scoped=true"
import script from "./CreateNomenclature.vue?vue&type=script&lang=js"
export * from "./CreateNomenclature.vue?vue&type=script&lang=js"
import style0 from "./CreateNomenclature.vue?vue&type=style&index=0&id=5a94a7dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a94a7dc",
  null
  
)

export default component.exports